import React from 'react';

import classNames from 'classnames';

import './ClearTemplateToggle.scss';

type Props = {
    checked: boolean;
    setChecked: (value: boolean) => void;

    disabled?: boolean;
};

const ClearTemplateToggle = ({ checked, setChecked, disabled }: Props) => (
    <label className={classNames('ClearTemplateTooggle', { disabled })}>
        <input type="checkbox" disabled={disabled} checked={checked} onChange={() => setChecked(!checked)} />
        <div className={classNames('checkbox', { checked })} /> Keep example content
    </label>
);

export default ClearTemplateToggle;
